module.exports = __webpack_public_path__ + "static/media/out.dd8ee416.glb";